import React, { useEffect, type ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { CommonEmptyDataV1 } from 'gemlux-common-components';
import AlertErrorSvg from '../../assets/img/alert-icon-circle.svg';
import { LayoutType } from '../../utils/enums/layout-type.enum';
import { modelAction } from '../../redux/models/modelsSlice';
import AppLayout from '../../components/V1/Layouts/AppLayout/AppLayout';

interface Layout {
  DashboardLayout: LayoutType;
  bgColor?: string;
}

export default function UnAuthorized({ DashboardLayout, bgColor }: Layout): ReactElement {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const firstPathPart = `/${pathParts[1]}`;

  useEffect(() => {
    dispatch(modelAction.setIsPermissionDeniedModelOpen(true));
  }, [firstPathPart]);

  return (
    <Box>
      <AppLayout layout={DashboardLayout} backgroundColor={bgColor}>
        <CommonEmptyDataV1
          // eslint-disable-next-line max-len
          description="You do not have the necessary rights to perform this action. Please contact your Administrator for assistance"
          title="Permission Denied!"
          icon={<Box component="img" src={AlertErrorSvg} alt="Alert Error" />}
        />
      </AppLayout>
    </Box>
  );
}
